import { BaseCheckbox } from '@service-victoria/component-library/components/Checkbox/BaseCheckbox';
import { Body } from '@service-victoria/component-library/components/Text/Body';
import React from 'react';

import InputField from 'Components/InputField';
import { InputProps } from 'Components/InputField/interfaces';

import * as Styled from './styled';

interface CheckboxField {
  defaultChecked?: boolean;
  label: string;
}

export interface Field {
  defaultValue?: string;
  value?: string;
  checkbox?: CheckboxField;
}

const InputFieldWithCheckBox = React.forwardRef<
  HTMLInputElement,
  InputProps & {
    field?: Field;
    checkboxProps?: React.ComponentProps<typeof BaseCheckbox>;
  }
>(function BaseInputFieldWithCheckBox({ field, checkboxProps, checked, ...inputProps }, ref) {
  return (
    <>
      {field?.checkbox && checkboxProps && (
        <Styled.Container>
          <BaseCheckbox
            {...checkboxProps}
            label={`${field.checkbox.label} ${field.defaultValue}`}
            data-testid={`${inputProps.name}CheckBox`}
            labelProps={{
              'data-testid': `${inputProps.name}CheckBoxLabel`,
              children: (
                <Body as='span'>
                  {field.checkbox.label} <strong>{field.defaultValue}</strong>
                </Body>
              )
            }}
            ref={checkboxProps.ref}
          />
        </Styled.Container>
      )}
      {!checked && <InputField {...inputProps} ref={ref} />}
    </>
  );
});

export default InputFieldWithCheckBox;
